import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';


const Header = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [activeLanguage, setActiveLanguage] = useState(i18n.language !== "ar" ? "fr" : i18n.language);
  const [viewport, setViewport] = useState('');

  useEffect(() => {
    i18n.changeLanguage(activeLanguage);
  }, [activeLanguage, i18n]);

  const handleLanguageClick = (lang) => {
    setActiveLanguage(lang);
  };

  useEffect(() => {
      function handleResize() {
          const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    
          if (viewportWidth < 991) {
            setViewport('mobile');
          } else {
            setViewport('desktop');
          }
        }
  
        handleResize();
        window.addEventListener('resize', handleResize);
  
        return () => window.removeEventListener('resize', handleResize);
  }, []); 

  return (
    <div className='container'>
      <div className='row'>
        <div className='container'>
          <nav className="navbar navbar-expand-lg navbar-light">
            <a className="navbar-brand" href="#">
              <img src="/assets/images/logo_ff.png" width="130px" alt="Logo" />
            </a>

            {viewport == 'desktop' && (
              <div className={`collapse navbar-collapse ${isNavbarOpen ? 'show' : ''}`} id="navbarText">
                <ul className="navbar-nav mx-auto mb-2 mb-lg-0 text-center">
                  <li className="nav-item">
                    <a className="nav-link" href="#about">{t('header.about')}</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#createteam">{t('header.createteam')}</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#faq">{t('header.faq')}</a>
                  </li>
                </ul>
              </div>
            )}
            <div className={`language-toggle d-flex mx-2 ${isArabic ? "me-auto" : "ms-auto"}`}>
                <button className={`language-button ${activeLanguage === 'fr' ? 'active' : ''} ${isArabic ? "language-button-arabic":""}`} onClick={() => handleLanguageClick('fr')}>
                  FR
                </button>
                <button className={`language-button ${activeLanguage === 'ar' ? 'active' : ''} ${isArabic ? "language-button-arabic":""}`} onClick={() => handleLanguageClick('ar')}>
                  AR
                </button>
            </div>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded={isNavbarOpen} aria-label="Toggle navigation" onClick={() => setIsNavbarOpen(!isNavbarOpen)}>
              <span className=""><img src="/assets/images/plus.jpg" width="30"></img></span>
            </button>

            {viewport == 'mobile' && (
              <div className={`collapse navbar-collapse ${isNavbarOpen ? 'show' : ''}`} id="navbarText" style={{border:"1px solid #367bf6",borderRadius:"8px"}}>
                <ul className="navbar-nav mx-auto mb-2 mb-lg-0 text-center" style={{padding:"0px"}}>
                  <li className="nav-item">
                    <a className="nav-link" href="#about">{t('header.about')}</a>
                  </li>
                  <hr style={{ borderColor: "#93999d",margin:"5px 30px" }}></hr>
                  <li className="nav-item">
                    <a className="nav-link" href="#createteam">{t('header.createteam')}</a>
                  </li>
                  <hr style={{ borderColor: "#93999d",margin:"5px 30px" }}></hr>
                  <li className="nav-item">
                    <a className="nav-link" href="#faq">{t('header.faq')}</a>
                  </li>
                </ul>
              </div>
            )}
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Header;